import { type ReactNode, useState } from 'react'

import { CopyButton } from '@/components/ui/CopyButton'
import { SearchableSelect, type SearchableSelectOption } from '@/components/ui/searchable-select'
import { Demo, DsSection } from '../primitives'

const TRAILERS: SearchableSelectOption[] = [
  {
    value: '561913',
    label: '2019 Utility Reefer',
    description: 'VIN 1UYVS2538KU561913 · Plate 4ABC123',
    keywords: ['561913'],
  },
  {
    value: '561914',
    label: '2019 Utility Reefer',
    description: 'VIN 1UYVS2538KU561914',
    keywords: ['561914'],
  },
  {
    value: '77',
    label: '2021 Wabash Dry Van',
    description: 'VIN 1JJV532D7ML123456 · Plate 7XYZ890',
    keywords: ['77'],
  },
]

const NOT_LISTED: SearchableSelectOption = { value: 'NOT_LISTED', label: 'Trailer not on this list' }

function PropDemo({ prop, children }: { prop: string; children: ReactNode }) {
  return (
    <div className="flex w-full max-w-sm flex-col gap-2">
      {children}
      <div className="text-ink-400 flex items-center gap-1 font-mono text-[10px]">
        <span>{prop}</span>
        <CopyButton
          value={prop}
          className="text-ink-400 hover:text-ink size-4 bg-transparent hover:bg-transparent"
        />
      </div>
    </div>
  )
}

export function SearchableSelectSection() {
  const [trailer, setTrailer] = useState<string>()
  const [pinned, setPinned] = useState<string>()

  return (
    <DsSection id="searchable-select" title="Searchable select">
      <Demo label="Default" className="grid grid-cols-1 gap-8 sm:grid-cols-2">
        <PropDemo prop="options={options}">
          <SearchableSelect
            options={TRAILERS}
            value={trailer}
            onChange={setTrailer}
            placeholder="Select trailer"
            searchPlaceholder="Search unit number, VIN or plate"
          />
        </PropDemo>
      </Demo>
      <Demo label="Pinned option" className="grid grid-cols-1 gap-8 sm:grid-cols-2">
        <PropDemo prop="footerOption={option}">
          <SearchableSelect
            options={TRAILERS}
            value={pinned}
            onChange={setPinned}
            footerOption={NOT_LISTED}
            placeholder="Select trailer"
            searchPlaceholder="Search unit number, VIN or plate"
          />
        </PropDemo>
      </Demo>
      <Demo label="States" className="grid grid-cols-1 gap-8 sm:grid-cols-2">
        <PropDemo prop="aria-invalid">
          <SearchableSelect
            options={TRAILERS}
            value={undefined}
            onChange={() => undefined}
            placeholder="Select trailer"
            aria-invalid
          />
        </PropDemo>
        <PropDemo prop="disabled">
          <SearchableSelect options={TRAILERS} value="77" onChange={() => undefined} disabled />
        </PropDemo>
      </Demo>
    </DsSection>
  )
}
